import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {SharedModule} from "../../common/shared.module";
// import {CreditCardDirectivesModule} from "angular-cc-library";  // temp comment out, because cc-library is not supported on ng18
import {TranslocoModule} from "@ngneat/transloco";
import {UserSettingsComponent} from "./user-settings/user-settings.component";
import {WizardUpgradeComponent} from "./wizard-upgarde/wizard-upgrade.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        MatMomentDateModule,
        TranslocoModule,
        // CreditCardDirectivesModule
    ],
    declarations: [
        UserSettingsComponent
    ],
    exports: []
})
export class UserModule {
}
